import http from "./http";

export const fetchProductData = () => http.get("/users/investments/products");
export const opportunities = (ProductTypeId) => http.get(`/users/investments/opportunities/${ProductTypeId}`);
export const fetchSingleProduct = (slug) => http.get(`/users/investments/products/${slug}`)